import * as History from 'history';
import { Route, Router } from '../../router';
import navbarmenu from '../navbar/navbar';
import homepage from '../pages/home';
import aboutpage from '../pages/about';
import contactpage from '../pages/contact';
import skillspage from '../pages/skills';
import developmentpage from '../pages/development';
import consultingpage from '../pages/consulting';
import workspage from '../pages/works';
import trainingpage from '../pages/training';
import training1 from '../pages/trainingcomponents/training1';
import training2 from '../pages/trainingcomponents/training2';
import training3 from '../pages/trainingcomponents/training3';
import supplementals from '../pages/trainingcomponents/supplementals';
import symitar from '../pages/trainingcomponents/trainingsymitar';
import registerpage from '../user/register';

const routes: Route[] = [
    { url: '', params: { page: 'home', title: 'Home' } },
    { url: 'about/:id:', params: { page: 'about', title: 'About Us' } },
    { url: 'training/:id:', params: { page: 'training', title: 'Development Classes' } },
    { url: 'skills', params: { page: 'skills', title: 'Our Skills' } },
    { url: 'development', params: { page: 'development', title: 'Custom Development' } },
    { url: 'consulting', params: { page: 'consulting', title: 'Tailored Consulting' } },
    { url: 'works', params: { page: 'works', title: 'Our Works' } },
    { url: 'contact', params: { page: 'contact', title: 'Contact Me' } },
    { url: 'register', params: { page: 'register', title: 'Register for iTech' } }
];

class RootViewModel {
    public route: KnockoutObservable<Route>;
    public router: Router;
    public message = ko.observable("");

    constructor(params: { basename: string, history: History.History }) {
        this.router = new Router(routes, params.basename, params.history);
        this.route = this.router.currentRoute;
        this.message("We will rock you at the root!");
        ko.components.register('navbar', navbarmenu);
        ko.components.register('home', homepage);
        ko.components.register('about', aboutpage);
        ko.components.register('contact', contactpage);
        ko.components.register('skills', skillspage);
        ko.components.register('development', developmentpage);
        ko.components.register('consulting', consultingpage);
        ko.components.register('works', workspage);
        ko.components.register('training', trainingpage);
        ko.components.register('training1', training1);
        ko.components.register('training2', training2);
        ko.components.register('training3', training3);
        ko.components.register('supplementals', supplementals);
        ko.components.register('symitar', symitar);
        ko.components.register('register', registerpage);
    }

    public dispose() {
        this.router.dispose();
        // TODO: Need a better API for this
        Object.getOwnPropertyNames((<any>ko).components._allRegisteredComponents).forEach(componentName => {
            ko.components.unregister(componentName);
        });
    }
}

export default { viewModel: RootViewModel, template: require('./root.html') };